import React from 'react';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { VseTextField } from '../utils/VseTextField';
import { VseCourseEditTemplate } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}));

export interface VseCourseHeaderGridProps {
  data: VseCourseEditTemplate,
  decodeSeason: (id: number) => string | undefined,
  decodeUniversity: (id: number) => string | undefined,
  decodeUniversityTerm: (seasonID: number, universityID: number, termCode: string) => string | undefined,
  decodeCourseStatus: (code: string) => string | undefined,
}

export function VseCourseHeaderGrid(props: VseCourseHeaderGridProps) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const courseCode = props.data.courseCode ? props.data.courseCode : '';

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid container>
          <Grid item xs={12} md={3}>
            <VseTextField
              label='VSE Season'
              required
              readOnly={true}
              value={props.decodeSeason(props.data.seasonID)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <VseTextField
              label='Course Offering University'
              required
              readOnly={true}
              value={props.decodeUniversity(props.data.univID)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <VseTextField
              label='Course Offering Term / Semester'
              required
              readOnly={true}
              value={props.decodeUniversityTerm(props.data.seasonID, props.data.univID, props.data.termCode)}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={3}>
            <VseTextField
              label='Course Code'
              required
              readOnly={true}
              value={courseCode}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <VseTextField
              label='Course Title'
              required
              readOnly={true}
              value={props.data.courseTitle}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <VseTextField
              label='Status'
              required
              readOnly={true}
              value={props.decodeCourseStatus(props.data.statusCode)}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
